var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 16.2501C25 22.5001 20.625 25.6251 15.425 27.4376C15.1527 27.5298 14.8569 27.5254 14.5875 27.4251C9.375 25.6251 5 22.5001 5 16.2501V7.50007C5 7.16855 5.1317 6.85061 5.36612 6.61619C5.60054 6.38177 5.91848 6.25007 6.25 6.25007C8.75 6.25007 11.875 4.75007 14.05 2.85007C14.3148 2.62382 14.6517 2.49951 15 2.49951C15.3483 2.49951 15.6852 2.62382 15.95 2.85007C18.1375 4.76257 21.25 6.25007 23.75 6.25007C24.0815 6.25007 24.3995 6.38177 24.6339 6.61619C24.8683 6.85061 25 7.16855 25 7.50007V16.2501Z",
    stroke: "#CCA466",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15L13.75 17.5L18.75 12.5",
    stroke: "#CCA466",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmp);
export default __webpack_public_path__ + "static/media/GMP.19776f9f9103be583c80e4b4396bd51c.svg";
export { ForwardRef as ReactComponent };